import {
    buttonClassName,
    pxToRem,
    labelClassName,
    pxArrayToRem,
    checkboxClassName,
    dialogClassName,
    dialogSlotClassNames,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const PinActionBar: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        margin: pxArrayToRem([49, 47, 0, 50]),
        columnGap: pxToRem(12),
        height: pxToRem(44),
        userSelect: 'none',
    },
    [theme.screen.clamped]: {
        marginRight: 0,
    },
});

export const CheckboxContainer: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        flexGrow: 1,
        alignSelf: 'center',
        [`& .${checkboxClassName}`]: {
            width: pxToRem(16),
            [`& .${labelClassName}`]: {
                marginLeft: pxToRem(12),
                whiteSpace: 'nowrap',
            },
            [`& .${svgIconClassName}`]: {
                '& path:last-child': {
                    stroke: theme.siteVariables.colors.white['000'],
                    strokeWidth: pxToRem(3),
                },
            },
        },
    },
});

export const ButtonDiv: StyleRule = ({ theme }) => ({
    [theme.screen.tablet]: {
        display: 'flex',

        [`& .${buttonClassName}`]: {
            height: pxToRem(44),
            border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
            [`& > .${labelClassName}`]: {
                fontSize: pxToRem(14),
                letterSpacing: '-0.01em',
                paddingRight: 0,
            },
            marginLeft: pxToRem(12),
            padding: pxArrayToRem([10, 19.5, 10, 19.1]),
        },
        [`& .${svgIconClassName}`]: {
            width: pxToRem(16),
            height: pxToRem(16),
        },
    },
});

export const DeleteDialog: StyleRule = () => ({
    minHeight: pxToRem(250),
    [`&.${dialogClassName}`]: {
        borderRadius: 0,
        width: pxToRem(450),
        padding: 0,
    },
    [`& .${dialogSlotClassNames.content}`]: {
        padding: 0,
    },
});
